import ModuleBase from '../shared/ModuleBase.js';

/**
 * NewsletterSubscribe — Progressive Enhancement der Blog-Newsletter-Form.
 *
 * Ohne JS: normaler POST an die Middleware (form action) — funktioniert weiterhin.
 * Mit JS: fetch ohne Reload, Inline-Status. Die serverseitige Middleware spricht
 * Acumbamail an (Double-Opt-In dort) — der API-Token verlässt nie den Server.
 *
 * Erwartet (data-ref): email, button, feedback. Statustexte als data-msg-* am <form>.
 */
export default class NewsletterSubscribe extends ModuleBase {
    constructor(el) {
        super(el);
        this._busy = false;
        this._init();
    }

    _init() {
        this.$el.addEventListener('submit', (e) => this._onSubmit(e));
    }

    async _onSubmit(e) {
        e.preventDefault();
        if (this._busy) return;

        const { email, button, feedback } = this.$refs;
        const msg = this.$el.dataset;

        if (!email || !email.value.trim() || !email.checkValidity()) {
            this._say(feedback, msg.msgInvalid, false);
            if (email) email.focus();
            return;
        }

        this._busy = true;
        if (button) button.disabled = true;
        this._say(feedback, msg.msgPending, null);

        try {
            const res = await fetch(this.$el.getAttribute('action'), {
                method: 'POST',
                headers: { Accept: 'application/json', 'X-Requested-With': 'fetch' },
                body: new FormData(this.$el),
            });
            const data = await res.json().catch(() => ({}));

            if (res.ok && data.success && data.code === 'already_subscribed') {
                this._say(feedback, msg.msgAlready || msg.msgSuccess, true);
                this.$el.reset();
            } else if (res.ok && data.success) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'newsletter_signup', method: 'acumbamail', list_id: '814674' });
                window.dataLayer.push({ event: 'generate_lead', lead_type: 'newsletter', method: 'acumbamail' });
                this._say(feedback, msg.msgSuccess, true);
                this.$el.reset();
            } else if (data.code === 'invalid_email') {
                this._say(feedback, msg.msgInvalid, false);
            } else {
                this._say(feedback, msg.msgError, false);
            }
        } catch (_err) {
            this._say(feedback, msg.msgError, false);
        } finally {
            this._busy = false;
            if (button) button.disabled = false;
        }
    }

    _say(node, text, state) {
        if (!node) return;
        node.textContent = text || '';
        node.hidden = !text;
        node.classList.remove('is-success', 'is-error', 'is-pending');
        if (state === true) node.classList.add('is-success');
        else if (state === false) node.classList.add('is-error');
        else if (state === null) node.classList.add('is-pending');
    }
}
